import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import { DeleteFormulaCardResponse, DeleteFormulaCardVariables } from '../types';

const deleteFormulaCardMutation = gql`
  mutation OvertimeDeleteFormulaCard($id: String!) {
    overtimeDeleteFormulaCard(id: $id) {
      code
      success
      message
    }
  }
`;

const deleteFormulaCard = (queryVariables: DeleteFormulaCardVariables) => {
  return graphQLApi<DeleteFormulaCardResponse, DeleteFormulaCardVariables>({
    query: deleteFormulaCardMutation,
    queryVariables,
  });
};

export default deleteFormulaCard;
